import { createApp, nextTick } from 'vue'
import { createFloating } from './directive/floating'
import { outside } from './services/outside'
import { getApp } from './container/app'

import App from './App.vue'

import './assets/scss/index.scss'

import { loadAnalytics } from './services/scripts'

async function bootstrap() {
  loadAnalytics()

  const appData = await getApp()

  const app = createApp(App)

  app.provide('appData', appData)

  const float = createFloating()
  app.use(float)
  app.use(outside)

  app.mount('#app')
}

bootstrap()
